<section class="w-full relative ">
	<div *ngIf="filterBanner.heading"
		 class="fb-filter-banner">
		<div class="px-4 md:px-10 text-center md:text-left md:flex-[70%]">
			<h1 class="fb-font-dm capitalize">{{filterBanner.heading}}</h1>
			<p class="fb-font-inter text-xs md:text-base ">
				{{filterSEO.metaDescription}}
			</p>
		</div>
		<div class="hidden md:flex justify-end md:flex-[30%] max-h-[250px]">
			<img class="object-contain"
				 [src]="filterBanner.image"
				 [alt]="filterSEO.metaDescription">
		</div>

	</div>
	<div *ngIf="selectedCategorySegments && selectedCategorySegments.length > 0"
		 class="px-4 md:pl-10 flex justify-start items-center gap-2 md:gap-14 mt-4">
		<h2 class="fb-font-dm text-xl hidden md:block">Shop By Category </h2>
		<div class="w-full md:w-max grid grid-cols-2 md:flex md:justify-start items-center gap-3 flex-wrap">
			<ng-container *ngFor="let segment of selectedCategorySegments">
				<a *ngIf="segment.name.toLowerCase() !== 'homeware'"
				   [href]="'/products/finished?category='+ this.selectedCategoryPage + '&' + removeSpace(segment.name) + '=all'"
					 class="flex items-center gap-1 cursor-pointer border border-[#D8D8D8] rounded px-2 hover:bg-[#F0F5FA] transition-colors">
					<img [src]="segment.icon" [alt]="segment.metaTitle"
						 class="w-16 h-16 object-cover object-center">
					<span class="fb-font-inter text-xs md:text-base font-medium capitalize">{{segment.name.toLowerCase()}}</span>
				</a>
			</ng-container>
		</div>
	</div>
	<div class="fb-filter-body flex flex-col md:flex-row justify-center items-stretch mt-10 mb-5 gap-4">
		<div class="w-full hidden md:block md:flex-[25%]">
			<div *ngIf="isLoading"
				 class="w-full flex flex-col items-stretch gap-y-2 mt-5">
				<div *ngFor="let skeleton of skeletonFilters"
					 class="w-full fb-skeleton text-transparent rounded-lg">{{skeleton}}</div>
			</div>
			<fb-filter-container *ngIf="!isLoading"
								 class="w-full"
								 [result]="filterResult"
								 [controls]="controls"
								 [showClearFilterButton]="showClearFilterButton"
								 [selectedFilters]="activeFilters"
								 (onControlsChange)="seekFilterChanges()"></fb-filter-container>
		</div>
		<div *ngIf="isLoading" class="w-full md:flex-[75%]">
			<div class="w-full">
				<div class="py-5 px-2 grid grid-cols-2 lg:grid-cols-3 gap-2 md:gap-x-8 md:gap-y-3">
					<fb-filter-product-preview-skeleton class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"></fb-filter-product-preview-skeleton>
					<fb-filter-product-preview-skeleton class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"></fb-filter-product-preview-skeleton>
					<fb-filter-product-preview-skeleton class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"></fb-filter-product-preview-skeleton>
					<fb-filter-product-preview-skeleton class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"></fb-filter-product-preview-skeleton>
					<fb-filter-product-preview-skeleton class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"></fb-filter-product-preview-skeleton>
					<fb-filter-product-preview-skeleton class="my-2 border border-[#75787F]/20 shadow md:shadow-md rounded md:rounded-xl"></fb-filter-product-preview-skeleton>
				</div>

			</div>
		</div>
		<div *ngIf="!isLoading"
			 class="w-full md:flex-[75%]">
			<div class="flex justify-center items-center gap-2 flex-col md:hidden">
				<fb-filter-active-controls (onControlsChange)="seekFilterChanges()"
										   [showClearFilterButton]="showClearFilterButton"
										   [selectedFilters]="activeFilters"
										   [controls]="controls"></fb-filter-active-controls>

				<button *ngIf="filterResult.length"
						class="w-max rounded text-[#7D5B20] py-1 px-3 bg-[#fffcf7]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm mb-4 mr-3">
					Showing <span class="font-medium">{{ filterResult.length }}</span> Products
				</button>
			</div>
			<div class="w-full flex justify-center md:justify-end items-center pt-12 md:pt-10 gap-3">
				<fb-filter-sort-dropdown (sortOption)="sortProducts($event)"
										 [selectedSortOption]="selectedSortOption"></fb-filter-sort-dropdown>
			</div>
			<fb-filter-product-grid class="w-full"
									[products]="pagedProductRelatedPreviews"
									[productGroup]="data.group"></fb-filter-product-grid>

			<div *ngIf="filterResult.length"
				 class="w-full flex justify-center items-center pt-12 md:pt-10 gap-3">
				<fb-filter-paginator [totalItems]="filterResult.length"
									 [itemsPerPage]="pageLength"
									 [currentPage]="pageNumber"
									 (pageChanged)="changePage($event)"></fb-filter-paginator>
			</div>
		</div>

	</div>
	<div class="fb-filter-sidebar w-[90%] fixed bg-white flex justify-center md:hidden pt-10"
		 [ngClass]="isSidebarOpen ? 'open': ''">
		<div *ngIf="isLoading"
			 class="w-[90%] h-screen flex flex-col items-stretch gap-y-2 mt-5">
			<div *ngFor="let skeleton of skeletonFilters"
				 class="w-full fb-skeleton text-transparent rounded-lg">{{skeleton}}</div>
		</div>
		<fb-filter-container *ngIf="!isLoading"
							 class="w-[90%] flex"
							 [result]="filterResult"
							 [controls]="controls"
							 [showClearFilterButton]="showClearFilterButton"
							 [selectedFilters]="activeFilters"
							 (onControlsChange)="seekFilterChanges()"></fb-filter-container>
	</div>
	<div (click)="isSidebarOpen = !isSidebarOpen"
		 class="w-full fixed bottom-0 z-[4] bg-[#8e7860] text-white py-2 text-center cursor-pointer md:hidden">
		<span *ngIf="!isSidebarOpen" class="text-lg">Filters ({{filterResult.length}})</span>
		<span *ngIf="isSidebarOpen" class="text-lg flex gap-1.5 items-center justify-center">
			View Products ({{filterResult.length}})<span class="material-symbols-outlined">close</span>
		</span>
	</div>
</section>
